export default __webpack_public_path__ + "static/media/piolun.3c21ef4d.svg";